import { gql } from "@apollo/client";

export const GET_USER_PARTNER_SETTINGS = gql`
  query UserPartnerSettings {
    userPartnerSettings {
      success
      errors {
        message
      }
      entries {
        partnerId
        partnerLogo
        partnerName
        partnerDescription
        clippingEnabled
        usernameType
        studioLoadoutType
      }
    }
  }
`;

export const UPDATE_USER_PARTNER_SETTINGS = gql`
  mutation UpdateUserPartnerSettings($input: [UserPartnerSettingsInput!]!) {
    updateUserPartnerSettings(input: $input) {
      success
      errors {
        message
      }
    }
  }
`;
